import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { routerShape, Link } from 'react-router';
import classNames from 'classnames';

class navigatorLink extends Component{
  render() {
    //split props into its components
    const { to, onlyActiveOnIndex, inactiveClassName, className, activeClassName, style, children } = this.props;
    const { router } = this.context;
    let linkClass = this.props.className;

    if (router) {
      const location = to;

      if (inactiveClassName) {
        if (!router.isActive(location, onlyActiveOnIndex)) {
          linkClass = classNames(className, inactiveClassName);
        }
      }
    }
    // ...props method added invalid props to the link object sparking a JS warning in console
    const linkProps = {
      children: children,
      className: linkClass,
      activeClassName: activeClassName,
      style: style
    };
    return (
      <Link to={to} onlyActiveOnIndex={onlyActiveOnIndex} {...linkProps} />
    );
  }
}

navigatorLink.contextTypes = {
  router: routerShape
};

navigatorLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  onlyActiveOnIndex: PropTypes.bool.isRequired,
  inactiveClassName: PropTypes.string
};

navigatorLink.defaultProps = {
  onlyActiveOnIndex: false
};

const NavigatorLink = navigatorLink;
export default NavigatorLink;
